import constants from './constants';

export const registrationImportEnabled = Boolean(process.env.REACT_APP_NODE_ENV === constants.ENVIRONMENTS.DEV);
